import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { BLOGS_API } from '../api/blog-api';
import { BlogEntityDuplicateInterface } from '../types/blog-entity-interface';
import { BlogPostId, BlogPostsInterface } from '../types/blog-posts-interface';
export const useDuplicateBlog = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      duplicateBlog: (id, data) => fetcher(`${BLOGS_API}/duplicate-background/${id}`, data)
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};